import React from 'react';
import { Tabs } from 'antd';
import AttributesTable from '../AttributesNav/AttributesTable';
import { useNavigate, useLocation } from 'react-router-dom';

const NavigationAttributes = ({ globalList, setGlobalList }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const pathToKeyMap = {
    '/app/attributes': 'attributes',
  };

  const keyToPathMap = {
    'attributes': '/app/attributes',
  };

  // Derive the tab key from current path
  const activeTab = pathToKeyMap[location.pathname] || 'attributes';

  const onChange = (key) => {
    navigate(keyToPathMap[key]);
  };

  const customTabBar = (props, DefaultTabBar) => (
    <div className="TabListTopBox">
      <DefaultTabBar {...props} />
    </div>
  );

  const items = [
    {
      key: 'attributes',
      label: 'Attributes',
      children: <AttributesTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
  ];

  return (
    <div className='TopTablesTabsBox TabNavigation'>
      <Tabs
        activeKey={activeTab}
        onChange={onChange}
        renderTabBar={customTabBar}
        className='TopTablesTabs'
        items={items}
      />
    </div>
  );
};

export default NavigationAttributes;
